import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { ApiResulNewExportModel, getPIMNewExportApi } from "@tecumseh/Services/PIMExportHistoryService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    customerId?: any;
    onError?: (errorMessage: string) => void;
    onSuccess?: (result: any) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResulNewExportModel>;

export const GetContents: HandlerType = async props => {
    if (props.parameter) {
        try {
            const result = await getPIMNewExportApi({ customerId: props.parameter.customerId });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.apiResult.errorMessage = error.errorJson.message;
                return;
            }
            throw error;
        }
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};


export const chain = [GetContents, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getPIMNewExport = createHandlerChainRunner(chain, "getPIMNewExport");
export default getPIMNewExport;
